/* NJS 2026 · header + hero video */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  /* header: solid past the hero, hide on scroll down, show on scroll up */
  const hdr = $('[data-header]');
  if (hdr) {
    let lastY = window.scrollY;
    const hero = $('main .hero');
    const solidAt = () => (hdr.classList.contains('hdr--overlay') && hero ? hero.offsetHeight - hdr.offsetHeight : 10);
    const onScroll = () => {
      const y = window.scrollY;
      hdr.classList.toggle('is-solid', y > solidAt());
      if (hdr.hasAttribute('data-hide-on-scroll')) {
        const busy = hdr.matches(':hover') || $('[data-mega].is-open', hdr) || document.body.classList.contains('no-scroll');
        if (y > lastY + 4 && y > 160 && !busy) hdr.classList.add('is-hidden');
        else if (y < lastY - 4 || y <= 160) hdr.classList.remove('is-hidden');
      }
      lastY = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  /* hero video: make sure it plays muted inline, respect reduced motion */
  $$('.hero video').forEach((v) => {
    v.muted = true; v.playsInline = true; v.loop = true; v.removeAttribute('controls');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { v.pause(); return; }
    const p = v.play(); if (p && p.catch) p.catch(() => {});
  });

  /* country + language selector: Shopify converts prices per market, we only send the choice */
  $$('[data-loc]').forEach((form) => {
    const item = $('.loc__item', form), toggle = $('[data-loc-toggle]', form);
    const country = $('[data-loc-country]', form), lang = $('[data-loc-lang]', form);
    toggle?.addEventListener('click', (e) => {
      e.preventDefault();
      const on = item.classList.toggle('is-open'); toggle.setAttribute('aria-expanded', on);
    });
    document.addEventListener('click', (e) => { if (!item.contains(e.target)) { item.classList.remove('is-open'); toggle?.setAttribute('aria-expanded', 'false'); } });
    $$('[data-country]', form).forEach((b) => b.addEventListener('click', () => {
      country.value = b.dataset.country;
      if (b.dataset.country !== 'BE') lang.value = 'en';
      form.submit();
    }));
    $$('[data-lang]', form).forEach((b) => b.addEventListener('click', () => { lang.value = b.dataset.lang; form.submit(); }));
  });

  /* close the mobile menu with Escape */
  document.addEventListener('keydown', (e) => {
    const d = $('#NavDrawer');
    if (e.key === 'Escape' && d && d.getAttribute('aria-hidden') === 'false') $('[data-drawer-close]', d).click();
  });
})();
